import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

//Módulos de angular
import { AppRoutingModule } from '@/app/app-routing.module';
import { AppComponent } from '@/app/app.component';
import { environment } from '@/environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { AuthModule } from '@auth0/auth0-angular';

//Plugins
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';

//Componentes de angular material
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatTabsModule} from '@angular/material/tabs';

//Componentes de primeng
import { Table, TableModule } from 'primeng/table';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { TabViewModule  } from "primeng/tabview";
import { InputMaskModule } from 'primeng/inputmask';

//Interceptors
import { TokenInterceptorService } from '@/app/services/security/token-interceptor.service';
import { RedirectInterceptorService } from '@/app/services/security/redirect-interceptor.service';

//Pipes
import { DatePipe } from '@angular/common';

//Componentes de la app
import { CargasComponent } from '@/app/components/cargas/cargas.component';
import { ReportesComponent } from '@/app/components/reportes/reportes.component';
import { LoginComponent } from '@/app/components/login/login.component';
import { NavbarComponent } from '@/app/components/shared/navbar/navbar.component';
import { ListaUsuariosComponent } from '@/app/components/catalogos/Usuarios/lista-usuarios/lista-usuarios.component';
import { CrearUsuarioComponent } from '@/app/components/catalogos/Usuarios/crear-usuario/crear-usuario.component';
import { EditarUsuarioComponent } from '@/app/components/catalogos/Usuarios/editar-usuario/editar-usuario.component';
import { ListaEstacionesComponent } from '@/app/components/catalogos/Estaciones/lista-estaciones/lista-estaciones.component';
import { CrearEstacionesComponent } from '@/app/components/catalogos/Estaciones/crear-estaciones/crear-estaciones.component';
import { EditarEstacionesComponent } from '@/app/components/catalogos/Estaciones/editar-estaciones/editar-estaciones.component';
import { ListaCombustiblesComponent } from '@/app/components/catalogos/Combustibles/lista-combustibles/lista-combustibles.component';
import { CrearCombustibleComponent } from '@/app/components/catalogos/Combustibles/crear-combustible/crear-combustible.component';
import { EditarCombustibleComponent } from '@/app/components/catalogos/Combustibles/editar-combustible/editar-combustible.component';
import { CrearFamiliaequipoComponent } from '@/app/components/catalogos/FamiliasEquipos/crear-familiaequipo/crear-familiaequipo.component';
import { EditarFamiliaequipoComponent } from '@/app/components/catalogos/FamiliasEquipos/editar-familiaequipo/editar-familiaequipo.component';
import { ListaFamiliaequipoComponent } from '@/app/components/catalogos/FamiliasEquipos/lista-familiaequipo/lista-familiaequipo.component';
import { CrearAlmacenComponent } from '@/app/components/catalogos/Almacenes/crear-almacen/crear-almacen.component';
import { EditarAlmacenComponent } from '@/app/components/catalogos/Almacenes/editar-almacen/editar-almacen.component';
import { ListaAlmacenesComponent } from '@/app/components/catalogos/Almacenes/lista-almacen/lista-almacenes.component';
import { ObtenerCompaniaComponent } from '@/app/components/catalogos/Compania/obtener-compania/obtener-compania.component';
import { InsertarCompaniaComponent } from '@/app/components/catalogos/Compania/insertar-compania/insertar-compania.component';
import { ModificarCompaniaComponent } from '@/app/components/catalogos/Compania/modificar-compania/modificar-compania.component';
import { CrearCargaComponent } from '@/app/components/cargas/crear-carga/crear-carga.component';
import { DetallesCargaComponent } from '@/app/components/cargas/detalles-carga/detalles-carga.component';
import { EnviarCargaComponent } from '@/app/components/cargas/enviar-carga/enviar-carga.component';
import { PreciosCombustiblesComponent } from "@/app/components/configuraciones/precios-combustibles/precios-combustibles.component";
import { PrecioContenidoComponent } from "@/app/components/configuraciones/precios-combustibles/precio-contenido/precio-contenido.component";
import { ListaActivosComponent } from '@/app/components/activos/lista-activos/lista-activos.component';
import { CrearActivoComponent } from '@/app/components/activos/crear-activo/crear-activo.component';
import { EditarActivoComponent } from '@/app/components/activos/editar-activo/editar-activo.component';
import { CuentaCreditoComponent } from '@/app/components/configuraciones/cuenta-credito/cuenta-credito.component';
import { ReenvioJustificacionComponent } from '@/app/components/cargas/reenvio-justificacion/reenvio-justificacion.component';


@NgModule({ declarations: [
        AppComponent,
        CargasComponent,
        ReportesComponent,
        LoginComponent,
        NavbarComponent,
        ListaUsuariosComponent,
        CrearUsuarioComponent,
        EditarUsuarioComponent,
        ListaEstacionesComponent,
        CrearEstacionesComponent,
        EditarEstacionesComponent,
        ListaCombustiblesComponent,
        CrearCombustibleComponent,
        EditarCombustibleComponent,
        CrearFamiliaequipoComponent,
        EditarFamiliaequipoComponent,
        ListaFamiliaequipoComponent,
        CrearAlmacenComponent,
        EditarAlmacenComponent,
        ListaAlmacenesComponent,
        ObtenerCompaniaComponent,
        InsertarCompaniaComponent,
        ModificarCompaniaComponent,
        CrearCargaComponent,
        DetallesCargaComponent,
        EnviarCargaComponent,
        PreciosCombustiblesComponent,
        PrecioContenidoComponent,
        ListaActivosComponent,
        CrearActivoComponent,
        EditarActivoComponent,
        CuentaCreditoComponent,
        ReenvioJustificacionComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        TableModule,
        MatDialogModule,
        RadioButtonModule,
        CheckboxModule,
        DropdownModule,
        ToastrModule.forRoot({
            positionClass: 'toast-top-right',
            preventDuplicates: true,
            closeButton: true
        }),
        NgxSpinnerModule.forRoot({ type: 'ball-clip-rotate' }),
        MatTooltipModule,
        CalendarModule,
        MatTabsModule,
        TabViewModule,
        InputMaskModule, 
        AuthModule.forRoot({
            ...environment.auth,
            cacheLocation: 'localstorage'
        }),], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptorService,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RedirectInterceptorService,
            multi: true
        },
        DatePipe,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        // Angular CDK 21 renderiza los overlays (MatDialog, tooltips, menús) en el
        // top layer del navegador con popover="manual". El top layer siempre se pinta
        // encima del resto del documento, así que SweetAlert2 quedaba detrás de los
        // diálogos. Con usePopover: false volvemos al apilamiento por z-index.
        {
            provide: OVERLAY_DEFAULT_CONFIG,
            useValue: { usePopover: false }
        },
    ] })
export class AppModule { }
